import { errorHandler } from "containers";
import { withMutation } from "./container";

import DeleteAccount from "./presentation";

const Component = withMutation(errorHandler(DeleteAccount));

export { Component as DeleteAccountButton };
